var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 0C16.3227 0 15.1287 0.409035 14.0762 1.21577C13.0673 1.98919 12.3955 2.97429 12 3.69061C11.6045 2.97424 10.9327 1.98919 9.92377 1.21577C8.87133 0.409035 7.67733 0 6.375 0C2.74069 0 0 2.94637 0 6.85353C0 11.0746 3.4192 13.9626 8.59542 18.3347C9.47442 19.0772 10.4707 19.9187 11.5063 20.8163C11.6428 20.9348 11.8181 21 12 21C12.1819 21 12.3572 20.9348 12.4937 20.8163C13.5293 19.9186 14.5256 19.0771 15.4051 18.3342C20.5808 13.9626 24 11.0746 24 6.85353C24 2.94637 21.2593 0 17.625 0Z",
    fill: "#2E3243"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.035fc3e4.svg";
export { ForwardRef as ReactComponent };